<template>
  <div>
    <div v-if="initLoading" class="text-xs-center pt-5">
      <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
    </div>
    <v-container v-else class="pt-5 pb-7">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Course Activity</v-toolbar-title>
                <v-spacer />
                <search-filter v-model="keywordSearch" />
            </v-toolbar>
            <v-data-table :headers="headers" :items="activityLogs" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
                <v-progress-linear slot="progress" color="secondary" indeterminate />
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.user.fullName }}</td>
                    <td>{{ props.item.location }}</td>
                    <td>{{ props.item.action }}</td>
                    <td>{{ props.item.createdAt | formatShortDateTime }}</td>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
  </div>
</template>
<script>
  import axios from 'axios';
  import ManageCourseBase from './ManageCourseBase.vue';

  export default {
    extends: ManageCourseBase,

    data: () => ({
      initLoading: true,
      activityLogs: [],
      headers: [
        { text: 'User', value: 'user.fullName', align: 'left' },
        {
          text: 'Location', value: 'location', align: 'left',
        },
        {
          text: 'Action', value: 'action', align: 'left',
        },
        {
          text: 'Date', value: 'createdAt', align: 'left',
        },
        ],
      keywordSearch: '',
      pagination: {
        descending: true, page: 1, rowsPerPage: 20, sortBy: 'createdAt',
      },
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
    }),

    props: {
        selectedTab: {
            type:String
        }
    },

    watch: {
      pagination: {
        handler() {
          this.getActivity();
        },
        deep: true,
        },
       keywordSearch() {
        this.processSearch();
        },
        selectedTab(val) {
            if (val == "ActivityLog") {
                this.getActivity().then(() => {
                    this.initLoading = false;
                });
            }
        }
    },

    mounted() {
      this.getActivity().then(() => {
        this.initLoading = false;
      });
    },

    methods: {
      async getActivity() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;
        const sortDirection = descending ? `${sortBy} DESC` : `${sortBy} ASC`;
        this.loading = true;
        const { data } = await axios.get(`/api/courses/${this.courseId}/audit-logs/paged?currentPage=${page}&pageSize=${rowsPerPage}&sortDirection=${sortDirection}&filter=${this.keywordSearch}`);
        this.activityLogs = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
        },
       processSearch: _.debounce(function () {
        this.getActivity();
      }, 600),
    },
  };
</script>